import { render, staticRenderFns } from "./CCard.vue?vue&type=template&id=02334e82&scoped=true"
import script from "./CCard.vue?vue&type=script&lang=js"
export * from "./CCard.vue?vue&type=script&lang=js"
import style0 from "./CCard.vue?vue&type=style&index=0&id=02334e82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02334e82",
  null
  
)

export default component.exports